import { render, staticRenderFns } from "./feedBait_mng.vue?vue&type=template&id=2171ada8"
import script from "./feedBait_mng.vue?vue&type=script&lang=js"
export * from "./feedBait_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2171ada8')) {
      api.createRecord('2171ada8', component.options)
    } else {
      api.reload('2171ada8', component.options)
    }
    module.hot.accept("./feedBait_mng.vue?vue&type=template&id=2171ada8", function () {
      api.rerender('2171ada8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_mng.vue"
export default component.exports